import Network from '@/services/network'

export default function () {
    const network = new Network;

    const fetchTypes = (query) => {
        return network.api('get', '/hr-payroll/attendance-policy/get-types' + query);
    }

    // ********************* Attendance-Policy-Start *****************
    const fetchAttendancePolicyList = (query) => {
        return network.api('get', '/hr-payroll/attendance-policy'+query);
    }

    const createAttendancePolicy = (data, query) => {
        return network.api('post', '/hr-payroll/attendance-policy'+query, data);
    }

    const fetchSingleAttendancePolicy = (policyId, query) => {
        return network.api('get', '/hr-payroll/attendance-policy/' + policyId + query);
    }

    const updateAttendancePolicy = (data, policyId, query) => {
        return network.api('put', '/hr-payroll/attendance-policy/'+ policyId + query, data);
    }
    // ********************* Attendance-Policy-End *****************

    // ********************* Attendance-Policy-Allocation-Start *****************
    const fetchAttendancePolicyAllocationList = (query) => {
        return network.api('get', '/hr-payroll/attendance-policy-allocation'+query);
    }

    const createAttendancePolicyAllocation = (data, query) => {
        return network.api('post', '/hr-payroll/attendance-policy-allocation'+query, data);
    }

    const fetchSingleAttendancePolicyAllocation = (allocationId, query) => {
        return network.api('get', '/hr-payroll/attendance-policy-allocation/' + allocationId + query);
    }

    const updateAttendancePolicyAllocation = (data, allocationId, query) => {
        return network.api('put', '/hr-payroll/attendance-policy-allocation/'+ allocationId + query, data);
    }
    // ********************* Attendance-Policy-Allocation-End *****************

    // ********************* Holiday-Start *****************
    const fetchHolidayList = (query) => {
        return network.api('get', '/hr-payroll/holidays'+query);
    }

    const createHoliday = (data, query) => {
        return network.api('post', '/hr-payroll/holidays'+query, data);
    }

    const fetchSingleHoliday = (holidayId, query) => {
        return network.api('get', '/hr-payroll/holidays/' + holidayId + query);
    }

    const updateHoliday = (data, holidayId, query) => {
        return network.api('put', '/hr-payroll/holidays/'+ holidayId + query, data);
    }
    // ********************* Holiday-End *****************

    // ********************* Attendance-Start *****************
    const fetchAttendanceList = (query) => {
        return network.api('get', '/hr-payroll/attendance'+query);
    }

    const createAttendance = (data, query) => {
        return network.api('post', '/hr-payroll/attendance'+query, data);
    }

    const fetchCurrentAttendanceInfo = (query) => {
        return network.api('get', '/hr-payroll/current-attendance' + query);
    }

    const updateAttendance = (data, attendanceId, query) => {
        return network.api('post', '/hr-payroll/attendance/update/'+ attendanceId + query, data);
    }
    // ********************* Attendance-End *****************

    // ********************* Manual-Attendance-Start *****************
    const fetchManualAttendanceList = (query) => {
        return network.api('get', '/hr-payroll/manual-attendance'+query);
    }

    const createManualAttendance = (data, query) => {
        return network.api('post', '/hr-payroll/manual-attendance'+query, data);
    }

    const fetchSingleManualAttendance = (attendanceId, query) => {
        return network.api('get', '/hr-payroll/manual-attendance/' + attendanceId + query);
    }

    const updateManualAttendance = (data, leavePolicyId, query) => {
        return network.api('put', '/hr-payroll/manual-attendance/'+ leavePolicyId + query, data);
    }
    // ********************* Manual-Attendance-End *****************

    // ********************* Leave-Policy-Start *****************
    const fetchLeavePolicyList = (query) => {
        return network.api('get', '/hr-payroll/leave-policy'+query);
    }

    const createLeavePolicy = (data, query) => {
        return network.api('post', '/hr-payroll/leave-policy'+query, data);
    }

    const fetchSingleLeavePolicy = (leavePolicyId, query) => {
        return network.api('get', '/hr-payroll/leave-policy/' + leavePolicyId + query);
    }

    const updateLeavePolicy = (data, leavePolicyId, query) => {
        return network.api('put', '/hr-payroll/leave-policy/'+ leavePolicyId + query, data);
    }
    // ********************* Leave-Policy-End *****************

    // ********************* Leave-Balance-Start *****************
    const fetchLeaveBalanceList = (query) => {
        return network.api('get', '/hr-payroll/leave-balance'+query);
    }

    const createLeaveBalance = (data, query) => {
        return network.api('post', '/hr-payroll/leave-balance'+query, data);
    }
    const deleteLeaveBalance = (query, id) => {
        return network.api('delete', '/hr-payroll/leave-balance/' + id + query);
    }
    const fetchSingleLeaveBalance = (leaveBalanceId, query) => {
        return network.api('get', '/hr-payroll/leave-balance/' + leaveBalanceId + query);
    }

    const updateLeaveBalance = (data, leaveBalanceId, query) => {
        return network.api('put', '/hr-payroll/leave-balance/'+ leaveBalanceId + query, data);
    }
    // ********************* Leave-Balance-End *****************

    // ********************* Leave-Balance-Start *****************
    const fetchMyLeaveList = (query) => {
        return network.api('get', '/hr-payroll/my-leave'+query);
    }
    // ********************* Leave-Balance-End *****************

    // ********************* Leave-Approver-Start *****************
    const fetchLeaveApproverList = (query) => {
        return network.api('get', '/hr-payroll/leave-approver'+query);
    }
    const createLeaveApprover = (data, query) => {
        return network.api('post', '/hr-payroll/leave-approver'+query, data);
    }
    const fetchSingleLeaveApprover = (leaveApproverId, query) => {
        return network.api('get', '/hr-payroll/leave-approver/' + leaveApproverId + query);
    }
    const updateLeaveApprover = (data, leaveApproverId, query) => {
        return network.api('put', '/hr-payroll/leave-approver/'+ leaveApproverId + query, data);
    }
    // ********************* Leave-Approver-End *****************

    // ********************* Leave-Application-Approval-Start *****************
    const fetchLeaveApplicationApproval = (query) => {
        return network.api('get', '/hr-payroll/leave-application-approval'+query);
    }
    const createLeaveApplicationApproval = (data, query) => {
        return network.api('post', '/hr-payroll/leave-application-approval'+query, data);
    }
    const fetchSingleLeaveApplicationLog = (leaveApplicationLogId, query) => {
        return network.api('get', '/hr-payroll/leave-application-approval/' + leaveApplicationLogId + query);
    }
    const updateLeaveApplicationApproval = (data, leaveApplicationLogId, query) => {
        return network.api('put', '/hr-payroll/leave-application-approval/'+ leaveApplicationLogId + query, data);
    }
    // ********************* Leave-Application-Approval-Start *****************

    // ********************* Leave-Application-Start *****************
    const fetchLeaveApplication = (query) => {
        return network.api('get', '/hr-payroll/leave-application'+query);
    }
    const fetchLeaveApplicationStatus = (query) => {
        return network.api('get', '/hr-payroll/leave-application-status'+query);
    }
    const fetchSingleLeaveApplication = (leaveApplicationId, query) => {
        return network.api('get', '/hr-payroll/leave-application/' + leaveApplicationId + query);
    }
    const createLeaveApplication = (data, query) => {
        return network.api('post', '/hr-payroll/leave-application'+query, data);
    }
    const updateLeaveApplication = (data, leaveApplicationId, query) => {
        return network.api('put', '/hr-payroll/leave-application/'+ leaveApplicationId + query, data);
    }
    const getLeaveApplicationNumberOfDays = (query) => {
        return network.api('get', '/hr-payroll/leave-application-number-of-days'+query);
    }
    // ********************* Leave-Application-End *****************

    const fetchAttendanceLogReport = (query) => {
        return network.api('get', '/hr-payroll/attendance-log-summary'+query);
    }

    const fetchAttendanceApproval = (query) => {
        return network.api('get', '/hr-payroll/attendance-approval'+query);
    }

    const updateAttendanceApproval = (data, query) => {
        return network.api('post', '/hr-payroll/attendance-approval'+query, data);
    }

    const fetchLeaveBalanceSummary = (query) => {
        return network.api('get', '/hr-payroll/leave-balance-summary'+query);
    }

    const fetchAttendanceSummaryReport = (query) => {
        return network.api('get', '/hr-payroll/attendance-summary'+query);
    }

    const fetchAttendanceReport = (query) => {
        return network.api('get', '/hr-payroll/attendance-report'+query);
    }

    const fetchContactItemLogs = (query) => {
        return network.api('get', '/company/contacts/employee-logs'+query);
    }

    // ********************* Pay-Head-Start *****************
    const fetchPayHead = (query) => {
        return network.api('get', '/hr-payroll/pay-heads'+query);
    }
    const fetchSinglePayHead = (payHeadId, query) => {
        return network.api('get', '/hr-payroll/pay-heads/' + payHeadId + query);
    }
    const createPayHead = (data, query) => {
        return network.api('post', '/hr-payroll/pay-heads'+query, data);
    }
    const updatePayHead = (data, payHeadId, query) => {
        return network.api('put', '/hr-payroll/pay-heads/'+ payHeadId + query, data);
    }
    // ********************* Pay-Head-End *****************

    // ********************* Pay-Head-Start *****************
    const fetchPayrollAdjustment = (query) => {
        return network.api('get', '/hr-payroll/payroll-adjustments'+query);
    }
    const fetchSinglePayrollAdjustment = (generalId, query) => {
        return network.api('get', '/hr-payroll/payroll-adjustments/' + generalId + query);
    }
    const createPayrollAdjustment = (data, query) => {
        return network.api('post', '/hr-payroll/payroll-adjustments'+query, data);
    }
    const updatePayrollAdjustment = (data, generalId, query) => {
        return network.api('put', '/hr-payroll/payroll-adjustments/'+ generalId + query, data);
    }
    // ********************* Pay-Head-End *****************

    // ********************* Salary-Structure-Start *****************
    const fetchSalaryStructure = (query) => {
        return network.api('get', '/hr-payroll/salary-structures'+query);
    }
    const createSalaryStructure = (data, query) => {
        return network.api('post', '/hr-payroll/salary-structures'+query, data);
    }

    const getEmployeeSalaryStructure = (query) => {
        return network.api('get', '/hr-payroll/employee-salary-structure'+query);
    }
    // ********************* Salary-Structure-End *****************

    // ********************* Salary-Grade-Scale-Start *****************
    const fetchSalaryGradeScale = (query) => {
        return network.api('get', '/hr-payroll/salary-grade-scale'+query);
    }
    const createSalaryGradeScale = (data, query) => {
        return network.api('post', '/hr-payroll/salary-grade-scale'+query, data);
    }
    // ********************* Salary-Grade-Scale-End *****************

    // ********************* Payroll-Start *****************
    const fetchPayrollProcessData = (query) => {
        return network.api('get', '/hr-payroll/get-payroll-process'+query);
    }
    const createPayrollProcessData = (query) => {
        return network.api('get', '/hr-payroll/payroll-process'+query);
    }

    const showPayrollProcessData = (payrollMasterId, query) => {
        return network.api('get', '/hr-payroll/payroll/'+ payrollMasterId +query);
    }

    const updatePayrollApprovalStatus = (data, query) => {
        return network.api('post', '/hr-payroll/payroll-approval' + query, data);
    }
    const createPayrollGenerateStatement = (data, query) => {
        return network.api('post', '/hr-payroll/payroll-generate-statement' + query, data);
    }

    const fetchPayrollStatementData = (query) => {
        return network.api('get', '/hr-payroll/get-payroll-statement'+query);
    }

    const showPayrollStatementData = (payrollStatementId, query) => {
        return network.api('get', '/hr-payroll/payroll-statement/'+ payrollStatementId +query);
    }

    const updatePayrollStatementPayslipIssue = (data, query) => {
        return network.api('post', '/hr-payroll/payroll-statement-payslip-issue' +query, data);
    }

    // ********************* Payroll-End *****************

    // ********************* Upload-Attendance-Start *****************

    const uploadAttendance = (data) => {
        return network.api('post', '/hr-payroll/upload-attendance', data);
    }
    const insertAttendance = (data) => {
        return network.api('post', '/hr-payroll/final-attendance-upload', data);
    }
    const deleteBulkUploadLog = (query, id) => {
        return network.api('delete', '/hr-payroll/delete-bulk-upload-log/' + id + query);
    }
    // ********************* Upload-Attendance-END *****************

    // ********************* Job-Requisition-Start *****************
    const fetchJobRequisition = (query) => {
        return network.api('get', '/hr-payroll/job-requisition'+query);
    }
    const fetchSingleJobRequisition = (jobReqId, query) => {
        return network.api('get', '/hr-payroll/job-requisition/' + jobReqId + query);
    }
    const createJobRequisition = (data, query) => {
        return network.api('post', '/hr-payroll/job-requisition'+query, data);
    }
    const updateJobRequisition = (data, jobReqId, query) => {
        return network.api('put', '/hr-payroll/job-requisition/'+ jobReqId + query, data);
    }
    const jobRequisitionApproval = (data, query) => {
        return network.api('post', '/hr-payroll/job-requisition-approval'+query, data);
    }
    const jobRequisitionPublish = (data, query) => {
        return network.api('post', '/hr-payroll/job-publish'+query, data);
    }
    // ********************* Job-Requisition-End *****************

    const fetchCareerListData = (query) => {
        return network.api('get', '/career'+query);
    }
    const fetchSinglePostJobData = (jobPostSlug, query) => {
        return network.api('get', '/career/'+jobPostSlug, +query);
    }

    const createJobApplication = (data) => {
        return network.api('post', '/job-application', data);
    }
    const fetchUserJobApplicationList = (userId, query) => {
        return network.api('get', '/user-job-application/'+ userId + query);
    }

    const fetchJobApplicationManage = (jobId, query) => {
        return network.api('get', '/hr-payroll/job-application-manage/'+ jobId + query);
    }
    const updateJobSelectionStatus = (data, query) => {
        return network.api('post', '/hr-payroll/update-job-selection-status'+query, data);
    }
    const updateJobApplicationStatus = (data, query) => {
        return network.api('post', '/hr-payroll/update-job-application-status'+query, data);
    }
    const fetchFinalSelectedJobApplications = (query) => {
        return network.api('get', '/hr-payroll/get-final-selected-job-applications' + query);
    }
    const fetchSingleJobApplication = (jobApplicationId, query) => {
        return network.api('get', '/hr-payroll/job-applications/'+ jobApplicationId + query);
    }
    const fetchSingleOfferLetter = (jobApplicationId, query) => {
        return network.api('get', '/hr-payroll/offer-letter/'+ jobApplicationId + query);
    }
    const createAppointment = (data, query) => {
        return network.api('post', '/hr-payroll/appointment' + query, data);
    }
    const fetchSingleAppointment = (appointmentId, query) => {
        return network.api('get', '/hr-payroll/appointment/'+ appointmentId + query);
    }
    const updateAppointment = (data, appointmentId, query) => {
        return network.api('put', '/hr-payroll/appointment/'+ appointmentId + query, data);
    }
    const updateAppointmentAcceptance = (data, appointmentId, query) => {
        return network.api('post', '/hr-payroll/appointment-update/'+ appointmentId + query, data);
    }
    const createEmployeeOffBoarding = (data, query) => {
        return network.api('post', '/hr-payroll/employee-off-boarding' + query, data);
    }
    const fetchEmployeeOffBoardingData = (query) => {
        return network.api('get', '/hr-payroll/employee-off-boarding'+query);
    }
    const fetchSingleEmployeeOffBoarding = (offBoardingId, query) => {
        return network.api('get', '/hr-payroll/employee-off-boarding/'+ offBoardingId + query);
    }
    const updateEmployeeOffBoarding = (data, offBoardingId, query) => {
        return network.api('post', '/hr-payroll/employee-off-boarding/'+ offBoardingId + query, data);
    }
    const fetchEmployeeOffBoardingApprovalData = (query) => {
        return network.api('get', '/hr-payroll/employee-off-boarding-approval'+query);
    }
    const createEmployeeOffBoardingRecommended = (data, query) => {
        return network.api('post', '/hr-payroll/employee-off-boarding-recommended' + query, data);
    }
    const fetchSingleEmployeeOffBoardingRecommended = (offBoardingId, query) => {
        return network.api('get', '/hr-payroll/employee-off-boarding-recommended/'+ offBoardingId + query);
    }
    const fetchEmployeeOffBoardingApprovalAssignUserData = (query) => {
        return network.api('get', '/hr-payroll/employee-off-boarding-assign-user'+query);
    }
    const fetchSingleEmployeeOffBoardingApprovalAssignUser = (offBoardingLogId, query) => {
        return network.api('get', '/hr-payroll/employee-off-boarding-assign-user/'+ offBoardingLogId + query);
    }
    const updateEmployeeOffBoardingApprovalAssignUser = (data, offBoardingId, query) => {
        return network.api('post', '/hr-payroll/employee-off-boarding-assign-user/'+ offBoardingId + query, data);
    }
    const fetchEmployeePayrollAdviceData = (employeeId, query) => {
        return network.api('get', '/hr-payroll/payroll-advice-setup/'+ employeeId + query);
    }
    const createEmployeePayrollAdviceData = (data, query) => {
        return network.api('post', '/hr-payroll/payroll-advice-setup' + query, data);
    }
    const getPayrollAdviceSummary = (payrollStatementId, query) => {
        return network.api('get', '/hr-payroll/payroll-advice-summary/'+ payrollStatementId +query);
    }
    const getPayrollAdviceData = (payrollStatementId, query) => {
        return network.api('get', '/hr-payroll/payroll-advice/'+ payrollStatementId +query);
    }
    const createPayrollAdvice = (data, query) => {
        return network.api('post', '/hr-payroll/payroll-advice' + query, data);
    }
    const fetchContactAttachmentReport = (query) => {
        return network.api('get', '/hr-payroll/contact-attachment-report'+query);
    }
    const getPayrollAdviceMasterList = (payrollStatementId, query) => {
        return network.api('get', '/hr-payroll/payroll-advice-master-list/'+ payrollStatementId +query);
    }
    const fetchSinglePayrollAdviceMaster = (payrollAdviceMasterId, query) => {
        return network.api('get', '/hr-payroll/payroll-advice-master/'+ payrollAdviceMasterId +query);
    }
    // ********************* Loan-Register-Start *****************
    const fetchLoanRegister = (query) => {
        return network.api('get', '/hr-payroll/loan-registers'+query);
    }
    const fetchSingleLoanRegister = (payHeadId, query) => {
        return network.api('get', '/hr-payroll/loan-registers/' + payHeadId + query);
    }
    const createLoanRegister = (data, query) => {
        return network.api('post', '/hr-payroll/loan-registers'+query, data);
    }
    const updateLoanRegister = (data, payHeadId, query) => {
        return network.api('put', '/hr-payroll/loan-registers/'+ payHeadId + query, data);
    }
    const fetchLoanRegisterStatement = (loanRegisterId, query) => {
        return network.api('get', '/hr-payroll/loan-registers/statement/'+ loanRegisterId + query);
    }
    // ********************* Pay-Head-End *****************

    const fetchPaySlipData = (query) => {
        return network.api('get', '/hr-payroll/pay-slip'+query);
    }
    const fetchSinglePaySlipData = (payrollStatementId, query) => {
        return network.api('get', '/hr-payroll/pay-slip/'+ payrollStatementId + query);
    }

    // ********************* Letter-Start *****************
    const fetchLetterList = (query) => {
        return network.api('get', '/hr-payroll/letters'+query);
    }

    const createLetter = (data, query) => {
        return network.api('post', '/hr-payroll/letters'+query, data);
    }

    const fetchSingleLetter = (holidayId, query) => {
        return network.api('get', '/hr-payroll/letters/' + holidayId + query);
    }

    const updateLetter = (data, holidayId, query) => {
        return network.api('put', '/hr-payroll/letters/'+ holidayId + query, data);
    }
    const getLetterTemplatePreview = (query) => {
        return network.api('get', '/hr-payroll/letter-template-preview'+query);
    }
    // ********************* Letter-End *****************

    // ********************* Performance-Component-Setup-Start *****************
    const fetchPerformanceComponentSetupList = (query) => {
        return network.api('get', '/hr-payroll/performance-component-setup'+query);
    }

    const createPerformanceComponentSetup = (data) => {
        return network.api('post', '/hr-payroll/performance-component-setup', data);
    }
    const fetchSinglePerformanceComponentSetup = (holidayId, query) => {
        return network.api('get', '/hr-payroll/performance-component-setup/' + holidayId + query);
    }

    const updatePerformanceComponentSetup = (data, componentId) => {
        return network.api('put', `/hr-payroll/performance-component-setup/${componentId}`, data);
    }
    const getPerformanceComponentSetupTree = (query) => {
        return network.api('get', '/hr-payroll/performance-component-setup-tree'+query);
    }
    // ********************* Performance-Component-Setup-End *****************

    // ********************* Performance-Apprisal-Setup-Start *****************
    const fetchPerformanceApprisalSetupList = (query) => {
        return network.api('get', '/hr-payroll/performance-apprisal-setup'+query);
    }

    const createPerformanceApprisalSetup = (data, query) => {
        return network.api('post', '/hr-payroll/performance-apprisal-setup'+query, data);
    }

    const fetchSinglePerformanceApprisalSetup = (setupId, query) => {
        return network.api('get', '/hr-payroll/performance-apprisal-setup/' + setupId + query);
    }

    const updatePerformanceApprisalSetup = (data, setupId, query) => {
        return network.api('put', '/hr-payroll/performance-apprisal-setup/'+ setupId + query, data);
    }
    // ********************* Performance-Apprisal-Setup-End *****************

    // ********************* Performance-Apprisal-Start *****************
    const fetchUserPerformanceAppraisal = (query) => {
        return network.api('get', '/hr-payroll/user-performance-appraisal'+query);
    }
    const createPerformanceApprisal = (data, query) => {
        return network.api('post', '/hr-payroll/performance-appraisal'+query, data);
    }
    const fetchPerformanceApprisal = (query) => {
        return network.api('get', '/hr-payroll/performance-appraisal'+query);
    }
    const fetchPerformanceAppraisalApproval = (query) => {
        return network.api('get', '/hr-payroll/performance-appraisal-approval'+query);
    }
    const createPerformanceApprisalScore = (data, query) => {
        return network.api('post', '/hr-payroll/performance-appraisal-score'+query, data);
    }
    const fetchTargetAchievementComponent = (query) => {
        return network.api('get', '/hr-payroll/target-achievement-component'+query);
    }
    const createTargetAchievement = (data, query) => {
        return network.api('post', '/hr-payroll/target-achievement'+query, data);
    }
    // ********************* Performance-Apprisal-End *****************

    const uploadProvidentFund = (data) => {
        return network.api('post', '/hr-payroll/upload-provident-fund', data);
    }
    const insertProvidentFund = (data) => {
        return network.api('post', '/hr-payroll/final-provident-fund-upload', data);
    }
    const fetchProvidentFundData = (query) => {
        return network.api('get', '/hr-payroll/provident-fund'+query);
    }

    // ********************* PayrollPreference-Start *****************
    const fetchPayrollPreferenceList = (query) => {
        return network.api('get', '/hr-payroll/payroll-preferences'+query);
    }
    const createPayrollPreference = (data, query) => {
        return network.api('post', '/hr-payroll/payroll-preferences'+query, data);
    }
    const fetchSinglePayrollPreference = (preferenceId, query) => {
        return network.api('get', '/hr-payroll/payroll-preferences/' + preferenceId + query);
    }
    const updatePayrollPreference = (data, preferenceId, query) => {
        return network.api('put', '/hr-payroll/payroll-preferences/'+ preferenceId + query, data);
    }
    // ********************* PayrollPreference-End *****************

    // ********************* Attendance-Schedule-Start *****************
    const fetchAttendanceScheduleCreate = (query) => {
        return network.api('get', '/hr-payroll/attendance-schedule/create'+query);
    }
    const fetchAttendanceScheduleList = (query) => {
        return network.api('get', '/hr-payroll/attendance-schedule'+query);
    }
    const storeAttendanceSchedule = (data, query) => {
        return network.api('post', '/hr-payroll/attendance-schedule'+query, data);
    }
    // ********************* Attendance-Schedule-End *****************

    const fetchProcessTrackerData = (query) => {
        return network.api('get', '/hr-payroll/get-process-tracker'+query);
    }
    const createProcessTracker = (query) => {
        return network.api('get', '/hr-payroll/process-tracker'+query);
    }

    const fetchDoctorAppointmentScheduleList = (query) => {
        return network.api('get', '/hr-payroll/doctor-appointment-schedule'+query);
    }

    return {
        fetchTypes,
        createAttendancePolicy,
        fetchAttendancePolicyList,
        fetchSingleAttendancePolicy,
        updateAttendancePolicy,
        fetchAttendancePolicyAllocationList,
        fetchSingleAttendancePolicyAllocation,
        createAttendancePolicyAllocation,
        updateAttendancePolicyAllocation,
        fetchHolidayList,
        createHoliday,
        fetchSingleHoliday,
        updateHoliday,
        fetchAttendanceList,
        createAttendance,
        fetchCurrentAttendanceInfo,
        updateAttendance,
        fetchManualAttendanceList,
        createManualAttendance,
        fetchSingleManualAttendance,
        updateManualAttendance,
        fetchLeavePolicyList,
        createLeavePolicy,
        fetchSingleLeavePolicy,
        updateLeavePolicy,
        fetchLeaveBalanceList,
        createLeaveBalance,
        deleteLeaveBalance,
        fetchSingleLeaveBalance,
        updateLeaveBalance,
        fetchMyLeaveList,
        fetchLeaveApproverList,
        createLeaveApprover,
        fetchSingleLeaveApprover,
        updateLeaveApprover,
        fetchLeaveApplicationApproval,
        fetchSingleLeaveApplication,
        createLeaveApplicationApproval,
        updateLeaveApplicationApproval,
        fetchLeaveApplication,
        fetchLeaveApplicationStatus,
        createLeaveApplication,
        getLeaveApplicationNumberOfDays,
        updateLeaveApplication,
        fetchSingleLeaveApplicationLog,
        fetchAttendanceLogReport,
        fetchAttendanceApproval,
        updateAttendanceApproval,
        fetchLeaveBalanceSummary,
        fetchAttendanceSummaryReport,
        fetchAttendanceReport,
        fetchContactItemLogs,
        fetchPayHead,
        fetchSinglePayHead,
        createPayHead,
        updatePayHead,
        fetchSalaryStructure,
        createSalaryStructure,
        getEmployeeSalaryStructure,
        fetchSalaryGradeScale,
        createSalaryGradeScale,
        createPayrollProcessData,
        fetchPayrollProcessData,
        showPayrollProcessData,
        updatePayrollApprovalStatus,
        createPayrollGenerateStatement,
        fetchPayrollStatementData,
        showPayrollStatementData,
        updatePayrollStatementPayslipIssue,
        uploadAttendance,
        insertAttendance,
        deleteBulkUploadLog,
        fetchJobRequisition,
        fetchSingleJobRequisition,
        createJobRequisition,
        updateJobRequisition,
        jobRequisitionApproval,
        jobRequisitionPublish,
        fetchCareerListData,
        fetchSinglePostJobData,
        createJobApplication,
        fetchUserJobApplicationList,
        fetchJobApplicationManage,
        updateJobSelectionStatus,
        updateJobApplicationStatus,
        fetchFinalSelectedJobApplications,
        fetchSingleJobApplication,
        createAppointment,
        fetchSingleAppointment,
        updateAppointment,
        fetchSingleOfferLetter,
        updateAppointmentAcceptance,
        createEmployeeOffBoarding,
        fetchEmployeeOffBoardingData,
        fetchSingleEmployeeOffBoarding,
        updateEmployeeOffBoarding,
        fetchEmployeeOffBoardingApprovalData,
        createEmployeeOffBoardingRecommended,
        fetchSingleEmployeeOffBoardingRecommended,
        fetchEmployeeOffBoardingApprovalAssignUserData,
        fetchSingleEmployeeOffBoardingApprovalAssignUser,
        updateEmployeeOffBoardingApprovalAssignUser,
        fetchPayrollAdjustment,
        fetchSinglePayrollAdjustment,
        createPayrollAdjustment,
        updatePayrollAdjustment,
        fetchEmployeePayrollAdviceData,
        createEmployeePayrollAdviceData,
        getPayrollAdviceSummary,
        getPayrollAdviceData,
        createPayrollAdvice,
        fetchContactAttachmentReport,
        getPayrollAdviceMasterList,
        fetchSinglePayrollAdviceMaster,
        fetchLoanRegister,
        fetchSingleLoanRegister,
        createLoanRegister,
        updateLoanRegister,
        fetchLoanRegisterStatement,
        fetchPaySlipData,
        fetchSinglePaySlipData,
        fetchLetterList,
        createLetter,
        fetchSingleLetter,
        updateLetter,
        getLetterTemplatePreview,
        fetchPerformanceComponentSetupList,
        createPerformanceComponentSetup,
        updatePerformanceComponentSetup,
        fetchSinglePerformanceComponentSetup,
        getPerformanceComponentSetupTree,
        fetchPerformanceApprisalSetupList,
        fetchSinglePerformanceApprisalSetup,
        createPerformanceApprisalSetup,
        updatePerformanceApprisalSetup,
        fetchUserPerformanceAppraisal,
        createPerformanceApprisal,
        fetchPerformanceAppraisalApproval,
        fetchPerformanceApprisal,
        createPerformanceApprisalScore,
        fetchTargetAchievementComponent,
        createTargetAchievement,
        uploadProvidentFund,
        insertProvidentFund,
        fetchProvidentFundData,
        fetchPayrollPreferenceList,
        createPayrollPreference,
        fetchSinglePayrollPreference,
        updatePayrollPreference,
        fetchAttendanceScheduleCreate,
        fetchAttendanceScheduleList,
        storeAttendanceSchedule,
        fetchProcessTrackerData,
        createProcessTracker,
        fetchDoctorAppointmentScheduleList
    }
}